import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'py-my-assortment-header',
  templateUrl: './my-assortment-header.component.html',
  styleUrls: ['./my-assortment-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MyAssortmentHeaderComponent {
  @Input() title: string;
  @Input() infoText: string;
}
